import { SubscriptionTypeFlags } from '../../../../../shared/constants/user-info/subscription';
import { CustomerSubscription } from '../../../../interfaces/customerSubscription';

export const getPriceForSubscription = (
  subscription: CustomerSubscription,
  subscriptionTypeFlags: SubscriptionTypeFlags,
) => {
  let price;

  if (subscriptionTypeFlags.REGULAR) {
    price = subscription.initialPlanPriceFinal;
  } else if (subscriptionTypeFlags.REACTIVATION || subscriptionTypeFlags.SCAN_IQ) {
    price = subscription.monthlyRenewalPriceFinal;
  }

  return price || 0;
};
